import en_US from './en-US/';
import vi from './vi/';
import test_lng from './test-LNG/';

export default {
  ...en_US,
  ...vi,
  ...test_lng,
};
